import React from "react";
import { Container, Row, Col, Image, Card, Button } from "react-bootstrap";
import tinSilverMain from "../Assets/Image/tin-silver-main.jpg"; // Replace with actual image
import tin1 from "../Assets/Image/tin-bar-1.jpg";
import tin2 from "../Assets/Image/tin-bar-2.jpg";
import tin3 from "../Assets/Image/tin-bar-3.jpg";
import tin4 from "../Assets/Image/tin-bar-4.jpg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const TinSilverPlatedCopperBars = () => {
  const navigate = useNavigate();
  const relatedProducts = [
    { name: "Plain Copper Bars", image: tin1 },
    { name: "Silver Coated Copper Bars", image: tin2 },
    { name: "Tin Coated Copper Strips", image: tin3 },
    { name: "High Conductivity Copper Bars", image: tin4 },
  ];

  return (
    <>
      <Helmet>
        <title>Tin/Silver Plated Copper Bars | Delta Engineering</title>
        <meta
          name="description"
          content="High-conductivity Tin and Silver Plated Copper Bars for switchgear, power distribution, telecom, and UPS applications. Offering superior corrosion resistance, durability, and conductivity."
        />
        <meta
          name="keywords"
          content="Tin Plated Copper Bars, Silver Plated Copper Bars, Copper Busbars, Tin Coated Copper Strips, High Conductivity Copper Bars, Corrosion Resistant Copper Bars, Copper Bars for Switchgear, Power Distribution Copper Busbars"
        />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="Tin/Silver Plated Copper Bars | Delta Engineering"
        />
        <meta
          property="og:description"
          content="Surface-finished copper bars engineered for corrosion resistance, low contact resistance, and long-term durability in electrical systems."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/tin-silver-plated-copper-bars"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/tin-silver-plated-copper-bars.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Tin/Silver Plated Copper Bars | Delta Engineering"
        />
        <meta
          name="twitter:description"
          content="High-performance Tin and Silver Plated Copper Bars with superior conductivity and corrosion resistance for power distribution and electrical panels."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/tin-silver-plated-copper-bars.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
               <span className="blue-text"> Tin/Silver </span>{" "}
            <span className="white-text">Plated Copper Bars</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                Enhanced surface finishes for corrosion resistance and long-term
                conductivity performance.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <div
        className="tin-silver-section py-3 bg-light"
        style={{ position: "relative" }}
      >
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">
                Tin/Silver Plated Copper Bars{" "}
                <span className="title-underline"></span>
              </h3>
              <p className="text-muted mb-4">
                Surface-finished copper bars that provide superior corrosion
                protection, lower contact resistance, and long-term durability
                in electrical installations.
              </p>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={4}>
              <Image
                src={tinSilverMain}
                fluid
                rounded
                alt="Tin/Silver Plated Copper Bar"
                height={500}
                width={400}
              />
            </Col>
            <Col md={8}>
              <h5 className="fw-semibold">Key Features:</h5>
              <ul className="text-muted ps-3">
                <li>High-conductivity copper base material (ETP Grade)</li>
                <li>Excellent corrosion and oxidation resistance</li>
                <li>Improved electrical contact performance</li>
                <li>Plating adheres tightly to copper surface</li>
                <li>Complies with RoHS & industry standards</li>
              </ul>

              <h5 className="fw-semibold mt-4">Available Finishes:</h5>
              <ul className="text-muted ps-3">
                <li>Tin Plated – Matte or Bright Finish</li>
                <li>Silver Plated – High conductivity and durability</li>
                <li>Optional Nickel undercoating for enhanced protection</li>
              </ul>
            </Col>
          </Row>

          <h4 className="fw-bold mt-5 mb-4 text-center">Related Products</h4>
          <Row className="g-4 mb-4">
            {relatedProducts.map((product, index) => (
              <Col key={index} xs={12} sm={6} md={3}>
                <Card className="h-100 text-center shadow-sm border-0">
                  <Card.Img
                    variant="top"
                    src={product.image}
                    alt={product.name}
                    style={{
                      height: "180px",
                      objectFit: "contain",
                      padding: "10px",
                    }}
                  />
                  <Card.Body>
                    <Card.Title className="text-muted fs-6">
                      {product.name}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <h5 className="fw-semibold">Applications:</h5>
          <ul className="text-muted ps-3">
            <li>Switchgear and control panels</li>
            <li>Automotive battery systems</li>
            <li>Power distribution units</li>
            <li>Busduct trunking systems</li>
            <li>Telecom and UPS infrastructure</li>
          </ul>

          <h5 className="fw-semibold mt-4">Specifications:</h5>
          <ul className="text-muted ps-3">
            <li>Material: ETP Copper (Cu ≥ 99.90%)</li>
            <li>Plating Thickness: Tin (5–15µm), Silver (5–10µm)</li>
            <li>Bar Size: 10mm – 200mm width, 3mm – 20mm thickness</li>
            <li>Conductivity: Up to 101% IACS</li>
            <li>Standard Length: 1000mm / 2000mm (customizable)</li>
          </ul>

          <h5 className="fw-semibold mt-4">Customization:</h5>
          <p className="text-muted">
            We offer tin/silver plating on custom-shaped copper busbars.
            Services include CNC machining, drilling, bending, stamping, and
            marking. Certificates and test reports provided on request.
          </p>
        </Container>
      </div>
    </>
  );
};

export default TinSilverPlatedCopperBars;
